if (!customElements.get('made-to-order')) {
  customElements.define(
    'made-to-order',
    class MadeToOrder extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');

        this.onOptionChange = this.onOptionChange.bind(this);
        this.productInfo?.addEventListener('change', this.onOptionChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (payload) =>
            this.onVariantChange(payload)
          );
        }

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.addEventListener('submit', this.onSubmit.bind(this));
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onOptionChange);
        this.unsubscribeVariantChange?.();
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      get buyButtons() {
        const root = this.productInfo || document;
        return root.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      }

      get quantityForm() {
        const root = this.productInfo || document;
        return root.querySelector(`#Quantity-Form-${this.sectionId}`);
      }

      setActive(active) {
        this.classList.toggle('hidden', !active);
        this.toggleAttribute('data-active', active);
        this.buyButtons?.classList.toggle('hidden', active);
        this.quantityForm?.classList.toggle('hidden', active);
      }

      onOptionChange(event) {
        if (this.contains(event.target)) return;
        this.setActive(false);
      }

      onVariantChange(payload) {
        const data = payload?.data;
        if (!data || data.sectionId !== this.sectionId) return;

        const source = data.html.querySelector(`#MadeToOrder-${this.sectionId}`);
        if (!source) return;

        const nextBody = source.querySelector('[data-mto-body]');
        const body = this.querySelector('[data-mto-body]');
        if (nextBody && body) body.innerHTML = nextBody.innerHTML;

        this.setActive(source.hasAttribute('data-active'));
      }

      onClick(event) {
        const toggle = event.target.closest('[data-mto-toggle]');
        if (!toggle) return;

        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId && this.querySelector(`#${panelId}`);
        if (!panel) return;

        const willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));

        if (willOpen) {
          panel.querySelector('input, textarea, select')?.focus();
        } else {
          toggle.focus();
        }
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        const panel = this.querySelector('.mto__panel');
        const toggle = this.querySelector('[data-mto-toggle]');
        if (panel && !panel.hidden) {
          panel.hidden = true;
          toggle?.setAttribute('aria-expanded', 'false');
          toggle?.focus();
        }
      }

      onSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const honeypot = form.querySelector('.mto__honeypot');
        if (honeypot && honeypot.value !== '') {
          event.preventDefault();
          return;
        }

        const submitButton = form.querySelector('[type="submit"]');
        if (!submitButton) return;

        if (submitButton.hasAttribute('disabled')) {
          event.preventDefault();
          return;
        }
        submitButton.setAttribute('disabled', 'disabled');

        if (typeof fetch !== 'function') return;

        event.preventDefault();
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then(() => {
            try {
              this.showSuccess(form);
            } catch (error) {
              console.error('made-to-order: showSuccess failed', error);
            }
          })
          .catch((error) => {
            console.error('made-to-order: request failed, falling back to native submit', error);
            form.submit();
          });
      }

      showSuccess(form) {
        const template = this.querySelector('[data-mto-success-template]');
        if (!template || !template.content) return;

        form.innerHTML = '';
        form.appendChild(template.content.cloneNode(true));
        form.querySelector('.mto__success')?.focus();
      }
    }
  );
}
